/** 前台 Middleware */
export default defineNuxtRouteMiddleware((middleware) => {
  const { path, params } = middleware
  const localePath = useLocalePath()

  if (/\/product-list[/]?$/.exec(path)) {
    if (!params || !params.id) {
      return navigateTo(localePath('/'))
    }
  }
})
